import { AlertTriangle, ShieldAlert } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useRestoreLock } from '../../api/queries/restore-lock';

// ─────────────────────────────────────────────────────────────
// Banner of the issuance lock a desktop restore left (AppLayout, beside
// the SFE version banner), for every signed-in user (#688): data restored
// read-only, or a restore being checked against the MCF, as the API words
// it. Nothing without a lock; errors render nothing.
// ─────────────────────────────────────────────────────────────

export function RestoreLockBanner() {
  const { data } = useRestoreLock();
  if (!data || !data.locked || data.notice === null) return null;

  const readOnly = data.state !== 'VERIFICATION';
  return (
    <div
      role={readOnly ? 'alert' : 'status'}
      className={cn(
        'mb-4 flex items-start gap-2 rounded-xl border px-4 py-3 text-sm',
        readOnly ? 'border-red-200 bg-red-50 text-red-800' : 'border-amber-200 bg-amber-50 text-amber-800'
      )}
    >
      {readOnly ? (
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
      ) : (
        <ShieldAlert className="mt-0.5 h-4 w-4 flex-shrink-0" />
      )}
      <p className="min-w-0">
        <span className="font-semibold">{readOnly ? 'Lecture seule après restauration' : 'Ventes suspendues'}</span> —{' '}
        {data.notice}
      </p>
    </div>
  );
}

export default RestoreLockBanner;
